export function getButtonLabel(awardedBid) {
  if (awardedBid === null) return 'Book'
  return 'Accept'
}
